import { IVariable } from "../../interfaces/IVariable";
import { createTheme, Theme } from "@mui/material/styles";
import { darkenColor } from "../../util/helpers";
import { getlocalStorageIdHotsite } from "../../util/LocalStorage";

let idHotsiteLocalStorage = getlocalStorageIdHotsite();

export const variables: IVariable = {
  IdHotsite: idHotsiteLocalStorage,
  Loja: "executive",
  UserStorage: "B6634CB2D4C245B08A1124C662F72311==",
  UserToken: "2E48EBD11C274D6AAA9C6D02C623634D==",
  UrlApi: "https://hlg-ecommerce-exc-api.primecase.com.br/api",
  UrlServiceHost: "https://dev2-pri-sgc-api.primecase.com.br/",
  UrlLoja: "",
  SecurityKey: "",
  OrgId: "",
  ProviderMerchantId: ""
};

export const template: Theme = createTheme({
  palette: {
    primary: {
      main: "#8E1B1B",
      light: "#9d3838",
      //lighter: "#ece6f7",
      dark: darkenColor("#8E1B1B", 10), // Escurece em 20%
    },
    secondary: {
      main: "#000000",
    },
    error: {
      main: "#a91c1c",
    },
    text: {
      primary: "#222",
      //light: "#fff",
    },
    warning: {
      main: "#ff9800",
    },
    // white: {
    //   main: "#fff",
    // },
  },

  typography: {
    subtitle1: {
      fontSize: 12,
    },
    body1: {
      fontSize: 14,
    },
  },
});
